import NewsSimple from './models/NewsSimple'
import NewsDetails from './models/NewsDetails'
import newsGateway, { NewsNoticeCondition, Page, PopNewsNoticeDTO } from '../../../gateway/PlatformNewNotice'
import NewsParam from './models/NewsParam'
import { Action, VuexModule, Mutation, getModule, Module } from 'vuex-module-decorators'
import store from '@/store'
import { ResponseStatus } from '../../../Response'

interface NewsModuleState {
  // 首页资讯
  newsList: Array<NewsSimple>
  // 资讯分页
  newsPageData: Array<NewsSimple>
  // 资讯 总数
  totalSize: number
  // 资讯 总页数
  totalPageSize: number
  // 首页默认读取条数
  defaultSize: number
  // 资讯详情
  newsDetails: NewsDetails
  // 资讯类别
  newsType: string
  /**
   * 当前时间内的弹窗公告
   */
  popNewsNoticeDTO: PopNewsNoticeDTO
}

@Module({ namespaced: true, dynamic: true, name: 'NewsModule', store })
class NewsModule extends VuexModule implements NewsModuleState {
  // 首页资讯
  newsList = new Array<NewsSimple>()
  // 资讯分页
  newsPageData = new Array<NewsSimple>()
  // 资讯 总数
  totalSize = 0
  // 资讯 总页数
  totalPageSize = 0
  // 首页默认读取条数
  defaultSize = 5
  // 资讯详情
  newsDetails = new NewsDetails()
  // 资讯类别
  newsType = 'EXAM_TREND'

  /**
   * 当前时间内的弹窗公告
   */
  popNewsNoticeDTO = new PopNewsNoticeDTO()

  @Action
  init(newsType: string) {
    this.SET_NEW_TYPE(newsType)
  }

  @Action
  async getNews(id: string): Promise<ResponseStatus> {
    const { status, data } = await newsGateway.getNewsNotice(id)
    const detail = new NewsDetails()
    Object.assign(detail, data)
    this.SET_NEWS_DETAILS(detail)
    return status
  }

  @Action
  async getList(params: NewsParam): Promise<ResponseStatus> {
    if (this.newsList.length > 0) {
      return new ResponseStatus(200, '')
    }
    const page = new Page()
    page.pageNo = 1
    page.pageSize = this.defaultSize
    const paramRemote = new NewsNoticeCondition()
    Object.assign(paramRemote, params)
    paramRemote.status = 1
    if (!paramRemote.categoryType) {
      paramRemote.categoryType = this.newsType
    }
    const { status, data } = await newsGateway.pageNewsNotice({ page: page, queryParam: paramRemote })
    const newsList = new Array<NewsSimple>()
    Object.assign(newsList, data.currentPageData)
    this.SET_NEWS_LIST(newsList)
    return status
  }

  @Action
  getList2(params: any): Promise<any> {
    const page = new Page()
    page.pageNo = params.pageNo
    page.pageSize = params.pageSize
    const paramRemote = new NewsNoticeCondition()
    // Object.assign(paramRemote, params)
    paramRemote.status = 1
    paramRemote.type = 1
    paramRemote.contendLength = 50
    if (!paramRemote.categoryType) {
      paramRemote.categoryType = this.newsType
    }
    // { status, data }
    return newsGateway.pageNewsNotice({ page: page, queryParam: paramRemote })
    // const newsList = new Array<NewsSimple>()
    // Object.assign(newsList, data.currentPageData)
    // this.SET_NEWS_LIST(newsList)
    //  data
  }

  @Action
  async getPage(params: { page: Page; queryParam: NewsParam }): Promise<ResponseStatus> {
    const paramRemote = new NewsNoticeCondition()
    Object.assign(paramRemote, params.queryParam)
    paramRemote.status = 1
    if (!paramRemote.categoryType) {
      paramRemote.categoryType = this.newsType
    }
    const { status, data } = await newsGateway.pageNewsNotice({ page: params.page, queryParam: paramRemote })
    const newsList = new Array<NewsSimple>()
    Object.assign(newsList, data.currentPageData)
    this.SET_NEWS_PAGE_DATA(newsList)
    this.SET_NEW_TYPE(params.queryParam.categoryType)
    this.SET_TOTAL_PAGE_SIZE(data.totalPageSize)
    this.SET_TOTAL_SIZE(data.totalSize)
    return status
  }

  @Action
  async getPopNews(queryParam: NewsParam): Promise<ResponseStatus> {
    const paramRemote = new NewsNoticeCondition()
    paramRemote.status = 1
    paramRemote.type = 2
    paramRemote.contendLength = -1
    paramRemote.unitIdList = queryParam.unitIdList
    const { status, data } = await newsGateway.getPopNewsNotice(paramRemote)
    this.SET_POP_NEWS(data)
    return status
  }

  @Mutation
  SET_NEWS_LIST(newsList: Array<NewsSimple>) {
    this.newsList = newsList
  }

  @Mutation
  SET_NEWS_PAGE_DATA(newsPageData: Array<NewsSimple>) {
    this.newsPageData = newsPageData
  }

  @Mutation
  SET_TOTAL_SIZE(totalSize: number) {
    this.totalSize = totalSize
  }

  @Mutation
  SET_TOTAL_PAGE_SIZE(totalPageSize: number) {
    this.totalPageSize = totalPageSize
  }

  @Mutation
  SET_NEWS_DETAILS(newsDetails: NewsDetails) {
    this.newsDetails = newsDetails
  }

  @Mutation
  SET_NEW_TYPE(newsType: string) {
    this.newsType = newsType
  }

  @Mutation
  SET_POP_NEWS(popNews: PopNewsNoticeDTO) {
    this.popNewsNoticeDTO = popNews
  }
}

export default getModule(NewsModule)
